/** Send and Forward Data to Whatsapp
 * @param recevier - Recevier Number
 * @param body - Text Data
*/
const sendWhatsApp = (recevier, body) => {
    window.open(`https://wa.me/91` + recevier + '?text=' + body, '_blank')
};

export default sendWhatsApp
